import { Component, OnInit } from '@angular/core';
import {version} from '../../../../package.json';
import moment from 'moment';

@Component({
  selector: 'app-member-layout',
  templateUrl: './member-layout.component.html',
  styleUrls: ['./member-layout.component.scss']
})
export class MemberLayoutComponent implements OnInit {

  appBuildVersion = version;
  year = moment().year();

  constructor() { }

  ngOnInit(): void {
  }

}
